import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { initialUpdateContactState } from "./ContactState";
import { AdditionalSettings } from "../../app/data/terminal-details/models";

const terminalService = TerminalService.getInstance();

export const updateAdditionalSettingsSlice = createSlice({
    name: "updateAdditionalSettings",
    initialState: initialUpdateContactState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setAdditionalSettings: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        }
    },
});

export const {
    loading,
    setAdditionalSettings,
    error
} = updateAdditionalSettingsSlice.actions;

export const updateAdditionalSettingsSelector = (state: IState) => state.updateAdditionalSettings;

// update terminal additional settings by terminal number
export const updateAdditionalSettings = (terminalNumber: string, data: AdditionalSettings, callback?: () => void, errorCallback?: (message: string | object) => void): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.updateAdditionalSettings(terminalNumber, data);
    if (response.ok()) {
        dispatch(setAdditionalSettings(data));
        callback?.();
    } else {
        if (response.getError()) {
            dispatch(error(response.getError()));
            if(typeof response.getError() === "string" && response.getError() !== "")
                errorCallback?.(response?.getError() || "Error! Please try again later...");
            else
                errorCallback?.("Error! Please try again later...");
        }
    }
};
//getAdditionalSettings
export const getAdditionalSettings = (terminalNumber: string): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.getAdditionalSettings(terminalNumber);
    if (response.ok()) {
        dispatch(setAdditionalSettings(response.data));
    } else {
        dispatch(error(response.getError()));
    }
};
const updateAdditionalSettingsReducer = updateAdditionalSettingsSlice.reducer;
export default updateAdditionalSettingsReducer;
